import { auth } from '../config/main_config';
import { getValidToken } from './utils/getValidToken.util';

interface APICallOptions {
  endpoint: string;
  method: 'GET' | 'POST';
  body?: Record<string, unknown>;
}

export async function internalAPICall({ endpoint, method, body }: APICallOptions): Promise<any> {
  const idToken = await getValidToken(auth);
  if (!idToken) {
    throw new Error('User not authenticated');
  }

  const fetchURL = (window.location.hostname.includes('localhost') || window.location.hostname.includes("127.0.0.1"))
    ? window.apiURL
    : import.meta.env.VITE_cloudFunctionURL;

  const headers: HeadersInit = {
    'Content-Type': 'application/json; charset=utf-8',
    'Authorization': `Bearer ${idToken}`,
    'Company-ID': window.companyID,
  };

  const options: RequestInit = {
    method,
    // mode: 'no-cors',
    headers,
    ...(method === 'POST' && body && { body: JSON.stringify(body) }),
  };

  try {
    const response = await fetch(`${fetchURL}${endpoint}`, options);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('Content-Type');

    // Determine response type based on Content-Type header
    if (contentType && contentType.includes('application/json')) {
      const jsonData = await response.json();
      return { ...jsonData };
    } else if (contentType && contentType.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')) {
      const blobData = await response.blob();
      return blobData;
    } else {
      throw new Error('Unsupported content type');
    }
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
}